export const USER_ROLES = [
    {
        id: 100,
        title: 'Administrátor',
    },
    {
        id: 50,
        title: 'Moderátor'
    },
    {
        id: 0,
        title: 'Instruktor'
    },
];
